import React from 'react'
import { useIsMobile } from 'hooks/useIsMobile'

export function TitlePage(props) {
    const {
        title
    } = props
    const { isMobile } = useIsMobile()

    return(
        <>
            {isMobile
                ? isMobile === 'desktop'
                    ?
                        <div className="tituloPage">
                            <p>{title}</p>
                        </div>
                    : null
                : null
            }
        </>
    )
}